import $ from 'jquery';
import { isElementDisabled } from '../util/dom.js';

// Lazy loaded plugin list (selector => initFunction)
const pluginSelectors = {

	/**
	 * Period selector form type
	 *
	 * @param {JQuery} $collection
	 */
	'[data-widget-period-selector]': ($collection) => {

		for (const elem of $collection) {
			const $elem = $(elem);
			const $periodSelector = $elem.find('[data-period-selector]');

			// ???? WTF? why do we need this?
			// $elem.find('[data-from-selector] input, [data-to-selector] input').on('change', (e) => {
			// 	e.stopImmediatePropagation();
			// });

			import('../mpro/modules/mpro.date-picker.js').then(({ initDatePicker }) => {

				const calendarFrom = $elem.find('[data-from-selector] [data-date-picker]')[0];
				const calendarTo = $elem.find('[data-to-selector] [data-date-picker]')[0];

				if (!isElementDisabled(calendarFrom) && !isElementDisabled(calendarTo)) {

					// ? This doesn't allow individual date to be cleared
					// const calendarPicker = initDatePicker(calendarFrom, {
					// 	singleMode: false,
					// 	splitView: true,
					// 	allowRepick: true,
					// 	numberOfColumns: 2,
					// 	numberOfMonths: 2,
					// 	elementEnd: calendarTo,
					// });

					const now = new Date();
					const fromDropdowns = { minYear: now.getFullYear() - 20, maxYear: now.getFullYear() + 20, months: true, years: 'asc' };
					const toDropdowns = { ...fromDropdowns };
					const calendarFromPicker = initDatePicker(calendarFrom, { dropdowns: fromDropdowns });
					const calendarToPicker = initDatePicker(calendarTo, { dropdowns: toDropdowns });

					calendarFromPicker.on('selected', (date) => {
						calendarToPicker.setOptions({ minDate: date, dropdowns: { ...toDropdowns, minYear: date?.getFullYear?.() || null } });
					});
					calendarToPicker.on('selected', (date) => {
						calendarFromPicker.setOptions({ maxDate: date, dropdowns: { ...fromDropdowns, maxYear: date?.getFullYear?.() || null } });
					});
				}
			});

			$periodSelector.on('change', (e) => {

				const $this = $(e.currentTarget);

				if (['custom'].includes(String($this.val()))) {
					e.stopImmediatePropagation();
				}

				if ($this.val() === 'custom') {
					$this.parent().removeClass('first-child').removeClass('last-child').addClass('d-none');
					$elem.find('[data-from-selector]').removeClass('d-none').addClass('first-child');
					$elem.find('[data-to-selector]').removeClass('d-none');
					$elem.find('[data-custom-selector-submit]').removeClass('d-none').addClass('last-child');
					$elem.find('[data-custom-selector-remove]').removeClass('d-none');
				}
				else {
					if ($this.val() === '') {
						$elem.find('[data-from-selector]').find('input').val('');
						$elem.find('[data-to-selector]').find('input').val('');
						$elem.find('[data-from-selector]').find('input').trigger('change');
						$elem.find('[data-to-selector]').find('input').trigger('change');
					}
					$this.parent().addClass('first-child').addClass('last-child').removeClass('d-none');
					$elem.find('[data-from-selector]').addClass('d-none').removeClass('first-child');
					$elem.find('[data-to-selector]').addClass('d-none');
					$elem.find('[data-custom-selector-submit]').addClass('d-none').removeClass('last-child');
					$elem.find('[data-custom-selector-remove]').addClass('d-none');
				}
			});

			$elem.find('[data-custom-selector-remove]').on('click', (e) => {
				$periodSelector.val($periodSelector.find('option:first').val()).trigger('change');
			});

			$periodSelector.trigger('change');
		}
	},
};

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {

	// Init plugins
	// TODO: make all plugin handlers async to prevent page hanging
	for (const [selector, handler] of Object.entries(pluginSelectors)) {

		/** @type {JQuery<any>} */
		const $collection = $container.find(selector);

		// Apply the handler to the collection
		if ($collection.length > 0) {
			handler($collection);
		}
	}
});